import axios from "axios";
const loadAbort = () => {
  return new AbortController();
};
export const getDataProjects = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDetailProject = (token: string, id: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects/${id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDetailProjectUnits = (
  token: string,
  id: string,
  filters?: Record<string, string | number>
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects/${id}/units`,
        params: filters,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


export const getTowerUnits = (
  token: string,
  id: string,
  filters?: Record<string, string | number>
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/developers/projects/${id}/units/tower`,
        params: filters,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};



export const getBookedUsers = (
  token: string,
  project_id: string,
  unit_id: string
) => {
  const controller = loadAbort();
  // https://api.propilatam.dev/pre-sales/v1/developers/projects/%7Bproject_id%7D/units/%7Bunit_id%7D/lanlords-booked/
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects/${project_id}/units/${unit_id}/lanlords-booked`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


export const getInvestorByProjects = (token: string, id: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects/${id}/investors`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getInvestorByProjectsBank = (token: string, id: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/banking/projects/${id}/investors/banking-analysis`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


export const getDetailUserUnit = (token: string, idProject: string, idUnit: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/projects/${idProject}/units/${idUnit}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};



export const sendAssignUnitClient = (id: string, data: any, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "post",
        url: `${urlService}/pre-sales/v1/developers/projects/${id}/units/assign-landlord`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


// https://api.propilatam.dev/pre-sales/v1/developers/projects/e2323/units/unassign-landlord

export const unassignLandlordToUnit = (id: string, data: any, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "delete",
        url: `${urlService}/pre-sales/v1/developers/projects/${id}/units/unassign-landlord`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

//https://api.propilatam.dev/pre-sales/v1/developers/projects/2323/units/2323/change-status

export const changeStatusUnit = (projectId: string, unitId: string, data: any, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "put",
        url: `${urlService}/pre-sales/v1/developers/projects/${projectId}/units/${unitId}/change-status`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

//https://api.propilatam.dev/pre-sales/v1/developers/kyc/unit/r64r6rtyf?page=1&take=10

export const getKycForUnits = (token: string, id: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/kyc/unit/${id}?page=1&take=50`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};


// https://api.propilatam.dev/pre-sales/v1/developers/kyc/unit/2323/detail/2323

export const getKycDetail = (token: string, id: string, kycId: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/kyc/unit/${id}/detail/${kycId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
}

//https://api.propilatam.dev/pre-sales/v1/developers/ky/unit/2323/detail/2323/compliance-report

export const getComplianceReport = (token: string, id: string, kycId: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "get",
        url: `${urlService}/pre-sales/v1/developers/kyc/unit/${id}/detail/${kycId}/compliance-report`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

//https://api.propilatam.dev/pre-sales/v1/developers/kyc/sasasqasassas/status


export const changeStatusKyc = (idKyc: string, token: string, data: any) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "put",
        url: `${urlService}/pre-sales/v1/developers/kyc/${idKyc}/status`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

// https://api.propilatam.dev/pre-sales/v1/developers/kyc/23323232/resend'
export const resendKYC = (idKyc: string, token: string, data: any) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "post",
        url: `${urlService}/pre-sales/v1/developers/kyc/${idKyc}/resend`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createDeveloperCustomer = (data: any, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "post",
        url: `${urlService}/user/v1/developer/customer`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createPreBooking = (data: { unit_id: string; landlord_id: string }, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: "post",
        url: `${urlService}/pre-sales/v1/developers/pre-booking`,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

/*
  Modificado por Daniel Bonilla Septiembre 2025
    - Se agregó la función getComplianceReport para obtener el reporte de cumplimiento en formato PDF.
*/